import httpStatus from "http-status"
import { PROCESS_ENV } from "~Shared/config/env.utils"

/**
 * Update methods (params, return type, etc.) below when changing the API
 */
export const LOGO_API = `https://img.logo.dev`

export const getLogoUrl = ({ domain, format }: { domain: string; format?: "png" | "webp" }) => {
    return `${LOGO_API}/${domain}?token=${PROCESS_ENV.LOGO_API_KEY}${format ? `&format=${format}` : ""}`
}

const checkLogo = async ({ url, abortController }: { url: string; abortController: AbortController }) => {
    const response = await fetch(`${url}&size=32&fallback=404`, { method: "GET", signal: abortController.signal })
    return {
        isFound: response.status === httpStatus.OK,
        url,
    }
}

const findLogos = async ({ searchString, abortController, domains }: { searchString: string; abortController: AbortController; domains: Array<string> }) => {
    const uncheckedLogos = domains.map((domain: string) => getLogoUrl({ domain: `${searchString}.${domain}` }))
    const checkedLogos = await Promise.all(uncheckedLogos.map((url) => checkLogo({ url, abortController })))
    const foundImages = checkedLogos.filter((checkedLogo) => checkedLogo.isFound).map((foundLogo) => foundLogo.url)
    return foundImages
}

const COMMON_LOGO_DOMAINS = ["com", "de"]
const UNCOMMON_LOGO_DOMAINS = ["fr"]

export const findLogosForAllDomains = async ({ searchString, abortController }: { searchString: string; abortController: AbortController }) => {
    const commonLogos = await findLogos({ searchString, abortController, domains: COMMON_LOGO_DOMAINS })
    if (commonLogos.length > 0) {
        return commonLogos
    }
    const uncommonLogos = await findLogos({ searchString, abortController, domains: UNCOMMON_LOGO_DOMAINS })
    return uncommonLogos
}
